import { Box, Grid2 as Grid, Typography } from "@mui/material";



const Footer = () => (    
    <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingLeft: '50px',
        paddingRight: '50px',
        minHeight: '70px',
        marginTop: '20px',
    }}>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            maxWidth: '1200px',
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingBottom: '20px',
        }}>
            <Typography sx={{
                fontFamily: 'Raleway',
                textTransform: 'none',
                fontSize: '12px',
                color: '#999999',
                textAlign: 'left',
                marginTop: '12px',
                width: '100%',

                maxWidth: '1200px',
                marginLeft: 'auto',
                marginRight: 'auto',
            }}>
                <span style={{
                    fontWeight: '600',
                }}>&#169; { new Date().getFullYear() } Numasuite Limited</span>. All rights reserved. Various trademarks held by their respective owners. 
            </Typography>
            <Typography sx={{
                fontFamily: 'Raleway',
                textTransform: 'none',
                fontSize: '12px',
                color: '#999999',
                textAlign: 'left',
                width: '100%',

                maxWidth: '1200px',
                marginLeft: 'auto',
                marginRight: 'auto',
            }}>
                NumaSuite Ltd, 10-16 Tiller Road, London, E14 8PX, United Kingdom. Company No. 16337252. VAT Reg No. GB 513029431. 
            </Typography>
            <Typography sx={{
                fontFamily: 'Raleway',
                textTransform: 'none',
                fontSize: '12px',
                color: '#999999',
                textAlign: 'left',
                width: '100%',

                maxWidth: '1200px',
                marginLeft: 'auto',
                marginRight: 'auto',
            }}>
            Telephone: 0333 880 4074. Email: sales@numasuite.co.uk
            </Typography>

            <Grid container width="100%" justifyContent="space-between" alignItems="center">
                <Grid size={12} textAlign={{ xs: "center", sm: "left" }}>
                    <Typography sx={{ fontFamily: 'Red Rose', textTransform: 'none', fontWeight: '600', fontSize: '13px', color: '#999999', marginTop: '12px' }}>Site Map</Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }} textAlign={{ xs: "center", sm: "left" }}>
                    <a href="/" style={{ textDecoration: 'none' }}>
                        <Typography sx={{ fontFamily: 'Red Rose', textTransform: 'none', fontWeight: '500', fontSize: '12px', color: '#999999' }}>Home</Typography>
                    </a>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }} textAlign={{ xs: "center", sm: "center" }}>
                    <a href="/about" style={{ textDecoration: 'none' }}>
                        <Typography sx={{ fontFamily: 'Red Rose', textTransform: 'none', fontWeight: '500', fontSize: '12px', color: '#999999' }}>About</Typography>
                    </a>
                </Grid>
                {/* <Grid size={{ xs: 6, sm: 3 }} textAlign={{ xs: "center", sm: "center" }}>
                    <a href="/products" style={{ textDecoration: 'none' }}>
                        <Typography sx={{ fontFamily: 'Red Rose', textTransform: 'none', fontWeight: '500', fontSize: '12px', color: '#999999' }}>Products</Typography>
                    </a>
                </Grid> */}
                <Grid size={{ xs: 12, sm: 4 }} textAlign={{ xs: "center", sm: "right" }}>
                    <a href="/contact-us" style={{ textDecoration: 'none' }}>
                        <Typography sx={{ fontFamily: 'Red Rose', textTransform: 'none', fontWeight: '500', fontSize: '12px', color: '#999999' }}>Contact Us</Typography>
                    </a>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }} textAlign={{ xs: "center", sm: "center" }}></Grid>
                <Grid size={{ xs: 12, sm: 4 }} textAlign={{ xs: "center", sm: "right" }}></Grid>
            </Grid>
        </Box>
    </Box>
);

export default Footer;